import { useApiQuery } from "@/api/useApi";
import type { Catalog } from "@/api/types";

/** The categories, expense types, brands and currencies set in Settings. */
export function useCatalog(): Catalog | undefined {
  return useApiQuery<Catalog>("/api/expenses/catalog").data;
}

/**
 * The categories this person may choose from. Some are kept for executives or named people;
 * until the list arrives, only categories open to everyone are offered.
 */
export function useUsableCategories(): Set<string> | undefined {
  const ids = useApiQuery<string[]>("/api/expenses/catalog/usable").data;
  return ids ? new Set(ids) : undefined;
}
